import script from "./PatientEditionPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatientEditionPage.vue?vue&type=script&setup=true&lang=ts"

import "./PatientEditionPage.vue?vue&type=style&index=0&id=278ae830&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-278ae830"]])

export default __exports__